import PropTypes from 'prop-types'

import Icon from '../Icons'

const ItemsPopup = ({ handleCancel, title, data, openMergeUnitTypesForm }) => {
  const { activeUnitTypes } = data

  return (
    <div className="items-popup">
      <div className="items-popup__container">
        <div className="window-header">
          <div className="title">{title}</div>
          <div className="navi-button" onClick={handleCancel}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">
          {activeUnitTypes.map((unitType) => (
            <div className="item-container" key={unitType}>
              {unitType}
            </div>
          ))}
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button
              type="submit"
              className="button button-black is-block"
              onClick={() => {
                handleCancel()
                openMergeUnitTypesForm(data)
              }}
            >
              {'Edit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ItemsPopup.propTypes = {
  handleCancel: PropTypes.func,
  openMergeUnitTypesForm: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
}

export default ItemsPopup
